import { render } from "./DispatcherPanel.vue?vue&type=template&id=777cd0a6&ts=true"
import script from "./DispatcherPanel.vue?vue&type=script&lang=ts"
export * from "./DispatcherPanel.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__